import { render, staticRenderFns } from "./DashboardAdjustment.vue?vue&type=template&id=076e7002&scoped=true&"
import script from "./DashboardAdjustment.vue?vue&type=script&lang=js&"
export * from "./DashboardAdjustment.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAdjustment.scss?vue&type=style&index=0&id=076e7002&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076e7002",
  null
  
)

export default component.exports